'use strict';

require('./KayleeService');
require('./RoomService');
var log = require('../../log/Log').channel('SetupSummaryController');
var defaults = require('../../defaults/Defaults');
var moment = require('moment');

angular.module('inara').controller('SetupSummaryController', 
                                   SetupSummaryController);

SetupSummaryController.$inject = ['$rootScope', '$scope', '$state', 
                                  'KayleeService', 'RoomService', '$interval',
                                  'gettextCatalog'];

function SetupSummaryController($rootScope, $scope, $state, 
                                KayleeService, RoomService, $interval,
                                gettextCatalog) {
    var vm = this;
    var clearSetupData = false;
    var finishTimeout = null;
    var finishTimeInterval = 1000;
    var finishTimeLeft = 0;

    log.info('initializing');

    $scope.$on('$ionicView.enter', function() {
        finishTimeLeft = defaults.inara.setupFinishTimeout;
        finishTimeout = $interval(onFinishTimeout, finishTimeInterval);
        clearSetupData = false;
        var controller = RoomService.getController();

        if (!controller.hasOwnProperty('roomId')) {
            log.error('controller not paired, going to pairing setup');
            $scope.goTo('setup.pairing');   
        }

        vm.company = KayleeService.getCompany(controller.companyId);
        vm.site = KayleeService.getSite(controller.siteId);
        vm.room = KayleeService.getRoom(controller.roomId);
        vm.equipment = vm.room.$getEquipment();
        vm.equipmentTypes = KayleeService.getEquipmentTypes();

        controller.$onChange(onControllerChanged);
    });

    // For some reason, $ionicView.leave isn't always called for this state.
    // (Maybe it is because when we leave this state, we don't go to another
    // setup sub-state.) So, we register with $stateChangeSuccess instead of
    // $ionicView.leave.

    $scope.$on('$stateChangeSuccess', function(event, toState, toParams, 
                                               fromState, fromParams) {
        if (fromState.name === 'setup.summary') {
            cancelFinishTimeout();

            var controller = RoomService.getController();
            if (controller !== null) controller.$offChange(onControllerChanged);

            if (clearSetupData) {
                $scope.clearSetupData(1000);
            }
        }
    });

    function onControllerChanged(controller) {
        if (!controller.hasOwnProperty('roomId')) {
            log.info('controller unpaired, going back to pairing setup');
            $scope.goTo('setup.pairing');
        }
    }

    function onFinishTimeout() {
        if (finishTimeLeft > 0) {
            finishTimeLeft -= finishTimeInterval;
        }
        else {
            log.debug('setup finish timeout, finishing');
            cancelFinishTimeout();
            vm.finish();
        }
    }

    function cancelFinishTimeout() {
        if (finishTimeout !== null) {
            $interval.cancel(finishTimeout);
            finishTimeout = null;
        }
    }

    /// Title bar for setup summary page
    vm.getViewTitle = function() { return gettextCatalog.getString('Setup Summary'); };

    vm.getConnectStateComparator = function(eq) {
        switch (eq.connectState) {
            case 'connectFailed':
            case 'authFailed':
            case 'controlFailed':
            case 'connecting':
                return -1;
            default:
                return 0;
        }
    };

    vm.getManufacturerComparator = function(eq) {
        return eq.$getManufacturer();
    };

    vm.getModelComparator = function(eq) {
        return eq.$getModel();
    };

    vm.finish = function() {
        // Save controller language again, in case controller was null due to
        // it being the first connection to Firebase/no offline cache existing 
        /// when initially on the language setup screen.
        var controller = RoomService.getController();
        controller.language = $scope.setup.language.code;
        controller.$save();
        clearSetupData = true;
        $state.go('start');
    };

    vm.finishTimedOut = function () {
        return finishTimeLeft === 0;
    };

    vm.getFinishDuration = function() {
        if (finishTimeLeft === 0) return '';

        var defaultSecondsMaxThreshold = moment.relativeTimeThreshold('s');
        var defaultSecondsMinThreshold = moment.relativeTimeThreshold('ss');
        var defaultRounding = moment.relativeTimeRounding();

        moment.relativeTimeThreshold('s', 61);
        moment.relativeTimeThreshold('ss', 0);
        moment.relativeTimeRounding(Math.ceil);
        var duration = moment(Date.now() + finishTimeLeft).fromNow();
        moment.relativeTimeThreshold('s', defaultSecondsMaxThreshold);
        moment.relativeTimeThreshold('ss', defaultSecondsMinThreshold);
        moment.relativeTimeRounding(defaultRounding);
        return duration;
    };

}

module.exports = SetupSummaryController;
